var wall = $('section.logostreifen');
var bar = wall.find('div');
$(window).scroll(function(c){
    bar.each(function(index){

        var shift = ($(window).scrollTop() - wall.scrollTop()) / 1000 * $(this).attr('speed');
        $(this).css('transform','translateX('+shift+'%)');

    });
});
